export const PRONUNCIATION_PASSING_SCORE = 60
